import * as React from 'react';

import { Button } from '../../../common/components/button';
import { ButtonPrintExcelGroupContainer } from '../bottom_print_excel/bottom_print_excel_container';
import { FeedbackPopupContainer } from './popup/container';
import { trackFeedbackButtonClick } from './tracking';

const style = require('./index.css');
const styleButton = require('../bottom_print_excel/index.css');

export interface IFeedbackState {
  isPopupVisible: boolean;
}

export class Feedback extends React.Component<{}, IFeedbackState> {
  public constructor(props: {}) {
    super(props);

    this.state = {
      isPopupVisible: false,
    };
  }

  public render() {
    const { isPopupVisible } = this.state;

    return (
      <div className={styleButton['buttonGroup']}>
        <ButtonPrintExcelGroupContainer />
        <Button theme="primary" mode="light" onClick={this.openPopup}>
          <span className={style['icon']} />
          Оставить отзыв
        </Button>
        {isPopupVisible && <FeedbackPopupContainer onClose={this.handlePopupClose} />}
      </div>
    );
  }

  private openPopup = () => {
    this.setState({
      isPopupVisible: true,
    });

    trackFeedbackButtonClick();
  };

  private handlePopupClose = () => {
    this.setState({
      isPopupVisible: false,
    });
  };
}
